import { useQuery, useMutation } from 'react-query'

import BlocktrainApi from './api'
import { QUERY_KEYS } from '../../api'

const useBlocktrain = (id: number | string, options = {}) => {
  const {
    data: blocktrain,
    isLoading: blocktrainIsLoading,
    refetch,
  } = useQuery([QUERY_KEYS.BLOCKTRAIN, id], () => BlocktrainApi.getById(id), {
    staleTime: 0,
    refetchOnWindowFocus: true,
    retry: 1,
    ...options,
  })
  const {
    mutate: updateBlockTrainStatus,
    isLoading: isUpdatingStatus,
    error: updateStatusError,
    isSuccess: isUpdateStatusSuccess,
  } = useMutation((newStatus: string) => BlocktrainApi.updateStatus(id, newStatus), {
    onSuccess: () => {
      refetch()
    },
    onError: error => {
      console.error('Error updating blocktrain status:', error)
    },
  })

  return {
    blocktrain,
    blocktrainIsLoading,
    refetchBlocktrain: refetch,
    updateBlockTrainStatus,
    isUpdatingStatus,
    updateStatusError,
    isUpdateStatusSuccess,
  }
}

export default useBlocktrain
